import { Field, Type, ArraySerializer } from 'serialize-ts';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';

export class Category {
  @Field()
  id: string;

  @Field()
  name: string;

  @Field()
  slug: string;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Category)))
  children?: Category[];

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Category)))
  parents?: Category[];

  // This field was added to for categories in filters
  @Field()
  totalCount?: number;

  //TODO This is added to cover /filter/ call
  // Check getTreeProjector in filter/selector.ts file
  // We will remove it after we decide what to do with category navigation design
  @Field()
  parent?: string;
}

export class OutOfScopeCategory extends Category {
  @Field()
  image: string;
}
